import { render } from "./teamWork.vue?vue&type=template&id=2e18213b"
import script from "./teamWork.vue?vue&type=script&lang=js"
export * from "./teamWork.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__